/* Small progressive enhancement for the gift-hub template.
   Creates stable anchor targets without changing global section markup. */
document.addEventListener('DOMContentLoaded', () => {
  const targets = [
    ['gift-picks', '__featured_collections_PYq6Ht'],
    ['gift-scene', '__collection_list_c6y6XT'],
    ['gift-budget', '__multi_column_qQmLUa'],
    ['gift-egift', '__image_with_text_xnR7gA']
  ];

  for (const [anchorId, sectionSuffix] of targets) {
    const section = document.querySelector(`[id$="${sectionSuffix}"]`);
    if (!section || document.getElementById(anchorId)) continue;

    section.style.position = section.style.position || 'relative';
    const anchor = document.createElement('span');
    anchor.id = anchorId;
    anchor.className = 'cradri-gift-anchor';
    anchor.setAttribute('aria-hidden', 'true');
    section.prepend(anchor);
  }
});
